import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[620px] md:h-[700px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Misty%20ancient%20Chinese%20mountain%20temple%20at%20dawn%2C%20a%20single%20warm%20glowing%20grass%20lantern%20in%20foreground%2C%20pine%20trees%20silhouettes%2C%20layered%20mountains%20in%20fog%2C%20ethereal%20atmosphere%2C%20traditional%20ink%20wash%20painting%20aesthetic%2C%20warm%20amber%20and%20deep%20green%20tones%2C%20zen%20and%20peaceful%2C%20vertical%20composition&width=1800&height=900&seq=hero-bg-2025&orientation=landscape"
        alt="草灯和尚 - 禅意山水"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/15 to-black/45"></div>
      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <p className="text-background-50/80 text-sm md:text-base tracking-[0.3em] font-label mb-6 uppercase">
          以草为灯 · 以心照路
        </p>
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 mb-6 leading-tight">
          草灯和尚
        </h1>
        <p className="text-background-50/80 text-base md:text-lg leading-relaxed max-w-2xl mx-auto mb-10">
          一位承载禅宗智慧与草木灵性的文化符号。<br/>
          探索禅意故事、修行哲学与生活美学，<br/>
          感受东方精神的深邃与温暖。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/chan-yi-gu-shi"
            className="px-8 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            探索禅意故事
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 rounded-full border border-background-50/30 text-background-50 font-medium text-sm hover:bg-background-50/10 transition-colors whitespace-nowrap"
          >
            了解草灯文化
          </Link>
        </div>
      </div>
    </section>
  );
}